// globalStyle.ts
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }: any) => theme.background};
    color: ${({ theme }) => theme.textColor};
    transition: background-color 0.3s, color 0.3s;
  }

  .ant-card {
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.textColor};
    transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  }

  .ant-table,
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    background-color: ${({ theme }) => theme.background} !important;
    color: ${({ theme }) => theme.textColor} !important;
  }

  .ant-tag {
    color: ${({ theme }) => theme.textColor};
  }
  .headerContent {
    background-color: ${({ theme }) => theme.background} !important;
    color: ${({ theme }) => theme.textColor};
    transition: background-color 0.3s, color 0.3s;
  }
    .card {
    background-color: ${({ theme }) => theme.background} !important;
    color: ${({ theme }) => theme.textColor};
    transition: background-color 0.3s, color 0.3s;
  }
    .ant-layout-content {
    background-color: ${({ theme }) => theme.background} !important;
    color: ${({ theme }) => theme.textColor};
    transition: background-color 0.3s, color 0.3s;
  }
`;
